import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/*
 * The standard centered page header: green eyebrow → Silkscreen title → 56×4px
 * green underline → optional mono subtitle (Servers / Games / Top100 / Seasons).
 */
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  subtitle?: ReactNode;
  className?: string;
}

export function PageHeader({ eyebrow, title, subtitle, className }: PageHeaderProps) {
  return (
    <header className={cn('mx-auto max-w-3xl text-center', className)}>
      <p className="font-display text-green text-[10px] uppercase tracking-[0.25em]">{eyebrow}</p>
      <h1 className="font-display text-strong mt-2 text-2xl sm:text-3xl">{title}</h1>
      <div className="bg-green mx-auto mt-3.5 h-1 w-14" aria-hidden />
      {subtitle ? <p className="text-dim mt-3 font-mono text-xs">{subtitle}</p> : null}
    </header>
  );
}
